import { render, staticRenderFns } from "./CardSummary.vue?vue&type=template&id=549943b1&scoped=true"
import script from "./CardSummary.vue?vue&type=script&lang=js"
export * from "./CardSummary.vue?vue&type=script&lang=js"
import style0 from "./CardSummary.vue?vue&type=style&index=0&id=549943b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549943b1",
  null
  
)

export default component.exports